import Axios from 'axios';

class RecipientsService {
  createManualTransfer(recipientId, amountToTransfer) {
    return Axios.post(`/admin/recipients/${recipientId}/manual-transfer`, {
      ...amountToTransfer,
    })
      .then(({ data }) => data);
  }

  reloadRecipientAmount(recipientId) {
    return Axios.get(`/admin/recipients/${recipientId}/reload-amounts`).then(({ data }) => data);
  }

  create(recipient, bankAccount) {
    return Axios.post('/admin/recipients', {
      ...recipient,
      ...bankAccount,
    })
      .then(({ data }) => data);
  }

  disable(recipientId) {
    return Axios.put(`/admin/recipients/${recipientId}/disable`).then(({ data }) => data);
  }

  enums() {
    return Axios.get('/admin/recipients/enums').then(({ data }) => data);
  }

  get(institutionId) {
    return Axios.get('/admin/recipients', {
      params: {
        institution_id: institutionId,
      },
    })
      .then(({ data }) => data);
  }

  update(recipientId, bankAccount) {
    return Axios.put(`/admin/recipients/${recipientId}/bank-account`, {
      ...bankAccount,
    })
      .then(({ data }) => data);
  }

  updateAllowTransfer(recipientId, allowTransferDesired) {
    return Axios.put(`/admin/recipients/${recipientId}/allow-transfer`, {
      allow_transfer_desired: allowTransferDesired,
    })
      .then(({ data }) => data);
  }

  getRecipientQueroPago() {
    return Axios.get('/admin/recipients/queropago-recipient')
      .then(({ data }) => data);
  }
}

export default new RecipientsService();
